import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
import { setError, setReceived, setGranted, setRequests, setRequestsPending, setRevokeGrantedAuthorization, setRevokingStatus, clearRevokingStatus, setUpdatingRequestStatus, clearUpdatingRequestStatus, setPostAuthorizationStatus, clearPostAuthorizationStatus, getAuthorizationsACL } from './actions';
export function getAdviserAuthorizations(cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/authorizations/received",
      method: 'GET',
      credentials: cookie,
      onSuccess: function onSuccess(data) {
        var obtained = {
          obtained: data.data
        };
        return dispatch(setReceived(obtained));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    });
  };
}
export function getAdviserAuthorizationsGranted(cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/authorizations/granted",
      method: 'GET',
      credentials: cookie,
      onSuccess: function onSuccess(data) {
        var granted = {
          granted: data.data
        };
        return dispatch(setGranted(granted));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    });
  };
}
export function getAdviserAuthorizationRequests(cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/authorizations/requests",
      method: 'GET',
      credentials: cookie,
      onSuccess: function onSuccess(data) {
        var requestsSent = {
          requestsSent: data.data
        };
        return dispatch(setRequests(requestsSent));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    });
  };
}
export function getAdviserAuthorizationRequestsPending(cookie) {
  return function (dispatch) {
    return finectAPI({
      version: 'v4',
      path: "users/me/authorizations/requests/pending",
      method: 'GET',
      credentials: cookie,
      onSuccess: function onSuccess(data) {
        var requestsReceived = {
          requestsReceived: data.data
        };
        return dispatch(setRequestsPending(requestsReceived));
      },
      onError: function onError(error) {
        return dispatch(setError(error));
      }
    });
  };
}
export function fetchRevokeAuthorization(id) {
  var scopes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var cookie = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch, getState) {
    var granted = getState().authorizations.granted;
    var auth = granted.find(function (item) {
      return item.id === id;
    });
    var path = "users/me/authorizations?profile=".concat(auth.profile.id, "&scopes=").concat(scopes.join(','));
    Promise.all([dispatch(setRevokingStatus(id, scopes))]).then(function () {
      return finectAPI({
        version: 'v4',
        path: path,
        method: 'DELETE',
        credentials: cookie || true,
        onSuccess: function onSuccess() {
          dispatch(getAdviserAuthorizationsGranted());
          dispatch(clearRevokingStatus());
        },
        onError: function onError(error) {
          dispatch(clearRevokingStatus());
          dispatch(setError(error));
        }
      });
    });
  };
}
export function fetchUpdateRequest(id) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'accept';
  var cookie = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch) {
    Promise.all([dispatch(setUpdatingRequestStatus(id, action))]).then(function () {
      var path = "users/me/authorizations/requests/".concat(id, "?action=").concat(action);
      return finectAPI({
        version: 'v4',
        path: path,
        method: 'PUT',
        body: {},
        credentials: cookie || true,
        onSuccess: function onSuccess() {
          Promise.all([dispatch(getAdviserAuthorizationRequestsPending()), dispatch(getAdviserAuthorizationsGranted()), dispatch(clearUpdatingRequestStatus())]);
        },
        onError: function onError(error) {
          dispatch(setError(error));
          dispatch(clearUpdatingRequestStatus());
        }
      });
    });
  };
}
export function postRequest(userID, scopes) {
  return function (dispatch) {
    return Promise.all([dispatch(setPostAuthorizationStatus(userID, scopes))]).then(function () {
      return finectAPI({
        version: 'v4',
        path: "users/me/authorizations/requests",
        method: 'POST',
        body: {
          user: userID,
          scopes: scopes
        },
        onSuccess: function onSuccess() {
          dispatch(clearPostAuthorizationStatus());
          dispatch(getAuthorizationsACL());
        },
        onError: function onError(error) {
          dispatch(clearPostAuthorizationStatus());
          if (error.status === 409) {
            return dispatch(setError({
              status: 409,
              customMessage: 'Contacta con el administrador de tu organización para solicitar permisos a este usuario.'
            }));
          }
          return dispatch(setError(error));
        }
      });
    });
  };
}